
















































import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
  components: {
  },
})
export default class Friend extends Vue {
  dialog= false;

  seluser={};

  mounted() {
    this.$store.dispatch('bindPeople');
    this.$store.dispatch('bindRecived');
    this.$store.dispatch('bindRequest');
    this.$store.dispatch('bindFriends');
  }

  showUserProfile(id: any) {
    this.$router.push(`/userProfile/${id}`);
  }

  sendRequests(user: any) {
    this.$store.dispatch('sendRequests', {
      collection: 'users',
      doc: {
        uid: this.currentUser.uid,
      },
      sendRequests: 'sendRequests',
      RecivedRequests: 'RecivedRequests',
      payload: {
        uid: user.uid,
      },
    });
  }

  // get users() {
  //   return this.$store.state.people.filter((user: any) => user.id !== this.currentUser.uid);
  // }
  get users() {
    const filtered = this.$store.state.people
      .filter((user: any) => (this.isKnownPerson(user) === 0)
      && (user.id !== this.currentUser.uid));
    return filtered;
  }

  isKnownPerson(user: any) {
    if (this.$store.state.friends.find((frnd: any) => (frnd.uid === user.uid))) {
      return 1;
    }
    if (this.$store.state.requests.find((frnd: any) => (frnd.uid === user.uid))) {
      return 2;
    }
    if (this.$store.state.reciveds.find((frnd: any) => (frnd.uid === user.uid))) {
      return 3;
    }
    return 0;
  }

  get currentUser() {
    return this.$store.state.currentUser;
  }
}
